{
  "name": "Pedal Harp 81-Odd 145-note layout",
  "description": "Harp scordatura for Marc Sabat's open instrumentation cycle “The Tree” (2023-). The scale allows every note of the harp to be tuned individually. To match the harp pedal mechanism, notes labelled with *f and *s lower or raise the respective diatonic note by ca. 100¢. A diatonic semitone is one degree and a diatonic tone spans 4 scale degrees, so each octave comprises a 22-note isomorphic pattern covering every pedal combination. To allow independent tuning of all 47 harp strings, the 22 notes are extended to 6 1/2 octaves, and the equave is set to 1/1, causing the pattern to repeat without transposition. The layout allows the entire set of notes to fit comfortably on a lumatone.",
  "scale": [
    "172.0",
    "7875.0",
    "0.",
    "172.0",
    "246.0",
    "410.0",
    "172.0",
    "346.0",
    "510.0",
    "586.0",
    "446.0",
    "610.0",
    "686.0",
    "755.0",
    "0.",
    "786.0",
    "855.0",
    "929.0",
    "1112.0",
    "955.0",
    "1029.0",
    "1212.0",
    "1294.0",
    "1129.0",
    "1312.0",
    "1394.0",
    "1446.0",
    "1633.0",
    "1494.0",
    "1546.0",
    "1733.0",
    "1802.0",
    "1646.0",
    "1833.0",
    "3/1",
    "1973.0",
    "2000.0",
    "2002.0",
    "2073.0",
    "2143.0",
    "2333.0",
    "2173.0",
    "2243.0",
    "2433.0",
    "2504.0",
    "2343.0",
    "2533.0",
    "9/2",
    "2675.0",
    "2845.0",
    "2704.0",
    "2775.0",
    "2945.0",
    "3013.0",
    "2875.0",
    "3045.0",
    "3113.0",
    "3199.0",
    "3200.0",
    "3213.0",
    "3299.0",
    "3356.0",
    "3550.0",
    "3399.0",
    "3456.0",
    "3650.0",
    "3718.0",
    "3556.0",
    "3750.0",
    "3818.0",
    "3892.0",
    "4068.0",
    "3918.0",
    "3992.0",
    "4168.0",
    "4234.0",
    "4092.0",
    "4268.0",
    "4334.0",
    "4406.0",
    "4400.0",
    "4434.0",
    "27/2",
    "4574.0",
    "4766.0",
    "4606.0",
    "4674.0",
    "4866.0",
    "4935.0",
    "4774.0",
    "4966.0",
    "5035.0",
    "5108.0",
    "5279.0",
    "5135.0",
    "81/4",
    "5379.0",
    "5451.0",
    "5308.0",
    "5479.0",
    "5551.0",
    "5618.0",
    "5600.0",
    "5651.0",
    "5718.0",
    "5794.0",
    "5986.0",
    "5818.0",
    "5894.0",
    "6086.0",
    "6153.0",
    "5994.0",
    "6186.0",
    "6253.0",
    "6326.0",
    "6488.0",
    "6353.0",
    "6426.0",
    "6588.0",
    "6670.0",
    "6526.0",
    "6688.0",
    "6770.0",
    "6838.0",
    "6800.0",
    "6870.0",
    "6938.0",
    "7010.0",
    "7087.0",
    "7038.0",
    "243/4",
    "7187.0",
    "7259.0",
    "7210.0",
    "7287.0",
    "7359.0",
    "7430.0",
    "7602.0",
    "7459.0",
    "7530.0",
    "171/2",
    "7875.0",
    "7630.0",
    "7802.0",
    "189/2",
    "1/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HS_A13-26no23",
  "built_in_group": "Scordatura",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "*nC",
    "",
    "",
    "",
    "D",
    "E|D",
    "*nE",
    "",
    "E",
    "F",
    "F",
    "E",
    "G",
    "G",
    "G",
    "",
    "( *sg1 )",
    "A",
    "( *fb1 )",
    "B",
    "A",
    "B",
    "C",
    "C",
    "C|B",
    "C",
    "D",
    "E|D",
    "E",
    "E",
    "E",
    "F",
    "G",
    "E",
    "F|F",
    "*nG",
    "G",
    "",
    "A|G",
    "( a2 )",
    "A",
    "B|C",
    "B|A",
    "B",
    "C",
    "C",
    "C|C",
    "C",
    "*nD",
    "D",
    "E",
    "E|D",
    "( e3 )",
    "F|F",
    "G",
    "F|F",
    "G|F",
    "( g3 )",
    "A",
    "",
    "G",
    "A|*nA",
    "A",
    "C",
    "B",
    "B",
    "C",
    "( *fd4 )",
    "B",
    "D",
    "D",
    "E",
    "F",
    "E",
    "E|E",
    "( f4 )",
    "F|F",
    "E",
    "G",
    "G|A",
    "A|G",
    "",
    "G|A",
    "*nA",
    "B|A",
    "B|C",
    "B",
    "B",
    "D",
    "C",
    "C|B",
    "D",
    "E",
    "D",
    "F",
    "E",
    "*nE",
    " ( f5 )",
    "G|F",
    "F|F",
    "G|G",
    "G",
    "G",
    "",
    "A|A",
    "B",
    "B",
    "B",
    "B|A",
    "B",
    "C",
    "D",
    "B|*nC",
    "D",
    "D",
    "E|E",
    "E",
    "( *sd6 )",
    "E",
    "F",
    "G|G",
    "F",
    "G",
    "G",
    "G|A",
    "",
    "( *sg6 )",
    "A",
    "A",
    "B",
    "B",
    "B|*nB",
    "B|B",
    "C",
    "C",
    "C",
    "D",
    "( *fe7 )",
    "E|*nE",
    "D",
    "E",
    "F",
    "",
    "E",
    "G",
    "G"
  ],
  "note_colors": [
    "ffbcbc",
    "d0d0d7",
    "dee2da",
    "737373",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "#ffadad",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "737373",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffe5e5",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff"
  ],
  "equivSteps": 146,
  "fundamental": 441,
  "reference_degree": 83,
  "center_degree": 44,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 8,
  "lumatone_anchor_channel": 2
}
